<template>
  <nd-select v-if="isSelectMode" v-model:value="value" class="filter-item-select" :options="props.options" :show-checkmark="false" />
  <bottom-drawer
    v-else
    :title="$t('sorting_label')"
    :showAction="false"
    :show-footer="true"
    :submitLabel="$t('all_confirm')"
    @submit="handleDrawerSubmit"
    @close="handleDrawerClose"
  >
    <template #trigger="{ open }">
      <nd-button type="icon" icon="sorting" @click="handleDrawerOpen(open)" />
    </template>
    <nd-radio-group v-model="selectorValue" :options="radioOptions" />
  </bottom-drawer>
</template>

<script setup lang="ts">
import BottomDrawer from '@/components/common/bottom-drawer.vue'
import NdRadioGroup from '@/components/form/nd-radio-group.vue'

const value = defineModel<string>()

const props = withDefaults(
  defineProps<{
    mode?: 'select' | 'icon'
    options?: {
      label: string
      value: string | number
    }[]
  }>(),
  {
    mode: 'select',
    options: () => [],
  }
)

// drawer
const selectorValue = ref('')
const isSelectMode = computed(() => props.mode === 'select')
const radioOptions = computed(() => props.options.map(option => ({ name: option.label, id: option.value })))

const handleDrawerOpen = (cb: Function) => {
  selectorValue.value = value.value || ''
  cb()
}

const handleDrawerSubmit = () => {
  value.value = selectorValue.value
}

const handleDrawerClose = () => {
  selectorValue.value = value.value || ''
}
</script>

<style lang="scss" scoped></style>
